import React, { useEffect, useState } from 'react';
import './members.scss'
import firebase, { storage } from '../../../utils/firebase'
import logo1 from '../../../assets/cropped-logo_white.png'
import { useDispatch, useSelector } from 'react-redux';
import { getCurrentTab } from '../../../redux/actions/adminSideMenuAction';
import Helmet from 'react-helmet'
import Alert from '../Alert';
import { setLanguageAlert, setMembersAlert } from '../../../redux/actions/adminActions';
import { countryList } from '../../auth/countries';
import MembersCard from './MembersCard';
import Paginate from '../Pagination';



const Members = () => {
    const [updateId, setUpdateId] = useState('')
    const [updateCreate, setUpdateCreate] = useState('')
    const [updateFullName, setUpdateFullName] = useState('')
    const [updateEmail, setUpdateEmail] = useState('')
    const [updatePhone, setUpdatePhone] = useState('')
    const [updateCountry, setUpdateCountry] = useState('')
    const [updatePicture, setUpdatePicture] = useState('')
    const [updatePictureUrl, setUpdatePictureUrl] = useState('')
    const [updateImage, setUpdateImage] = useState('')
    const [uploadClick, setUploadClick] = useState(false)
    const [uploadStage, setUploadStage] = useState('')
    const [uploadProgress, setUploadProgress] = useState('')
    const [userCreate, setUserCreate] = useState('')
    const [pictureUrl, setPictureUrl] = useState('')
    const [offset, setOffset] = useState(10)
    const [noOfPages, setNoOfPages] = useState('')
    const [pageArray, setPageArray] = useState([])
    const [noOfData, setNoOfData] = useState('')
    const [loadedData, setLoadedData] = useState([])
    const [activePage, setActivePage] = useState(1)
    const [fullName, setFullName] = useState('')
    const [userData, setUserData] = useState([])
    const [echange, setEchange] = useState(true)
    const [edit, setEdit] = useState(false)
    const [editId, setEditId] = useState('')
    const [email, setEmail] = useState('')
    const [phone, setPhone] = useState('')
    const [country, setCountry] = useState('')
    const [picture, setPicture] = useState('')
    const [alertMessage, setAlertMessage] = useState('')
    const [deleteId, setDeleteId] = useState('')
    const alert = useSelector(state => state.alert)
    const { membersAlertStatus } = alert
    const [pageState, setPageState] = useState('')
    const [hh, sethh] = useState('')
    const dispatch = useDispatch()

    const makeUpload = (file, fileName) => {
        const uploadTask = storage.ref(`/images/${fileName}`).put(file)
            //initiates the firebase side uploading 
            uploadTask.on('state_changed', 
            (snapShot) => {
                const progress = Math.round((snapShot.bytesTransferred / snapShot.totalBytes) * 100)
                setUploadProgress(progress)
                setUploadStage('loading')
            //takes a snap shot of the process as it is happening
            }, (err) => {
            //catches the errors
            setUploadProgress(err)
            }, () => {      }
            )
    }

    useEffect(() => {
        if(updateCreate) {
            if(uploadProgress === 100) {
                setUploadProgress('Uploading')
                setTimeout(() => {    
                    storage.ref('images').child(picture.name).getDownloadURL()
                    .then(fireBaseUrl => {
                    setUpdateImage(fireBaseUrl)
                    })
                }, 2000);

                
            }
        }

        if(userCreate) {
            if(uploadProgress === 100) {
                setUploadProgress('Uploading')
                setTimeout(() => {
                    storage.ref('images').child(picture.name).getDownloadURL()
                    .then(fireBaseUrl => {
                        setPictureUrl(fireBaseUrl)
                    })     
                }, 2000);
            }
        }
        
    }, [picture.name, updateCreate, uploadProgress, userCreate])

    useEffect(() => {
        dispatch(getCurrentTab('members'))
    }, [dispatch])

    const numArr = (num) => {
        const arr = []
        for (let i = 1; i <= num ; i++) {
          arr.push(i)
        }
        return arr
    }

    useEffect(() => {
        if (userCreate) {
            if (pictureUrl) {   
                const rr = Date.now() 
                const usersRef = firebase.database().ref('User')
                let newUser = {
                    name: fullName,
                    email: email,
                    phone: phone,
                    country: country,
                    profilePicture: pictureUrl,
                    joinedAt: new Date()
                }
    
                usersRef.push(newUser)
                setEchange(!echange)
                setPhone('')
                setFullName('')
                setCountry('')
                setEmail('')
                setPicture('')
                setPictureUrl('')
                setUploadProgress('')
                setUploadStage('')
                setUploadClick(false)
                document.querySelector('.admin-background').classList.add('hide')
                document.querySelector('.mem-form-container').classList.add('hide')
                setEdit(false)
                setEditId('')
                setUserCreate(false)
            }
        }
    }, [country, echange, email, fullName, phone, pictureUrl, userCreate]);

    useEffect(() => {
        if (updateCreate) {      
            if(updateImage) {
            
                setPhone(updatePhone)
                setFullName(updateFullName)
                setCountry(updateCountry)
                setEmail(updateEmail)
                setPicture(updatePicture)
                setPictureUrl(updatePictureUrl)

                const userRef = firebase.database().ref('Users').child(updateId)
                userRef.update({
                    name: fullName,
                    email: email,
                    phone: phone,
                    country: country,
                    profilePicture: updateImage,
                    updatedAtDate: new Date()
                })

                setUpdateId('')
                setUpdateImage('')
                setEchange(!echange)
                setPhone('')
                setFullName('')
                setCountry('')
                setEmail('')
                setPicture('')
                setPictureUrl('')
                setUploadProgress('')   
                setUploadStage('')
                setUploadClick(false)
                document.querySelector('.lang-background').classList.add('hide')
                document.querySelector('.mem-form-container').classList.add('hide')
                setEdit(false)
                setEditId('')
                setUpdateFullName('')
                setUpdatePhone('')
                setUpdateCountry('')
                setUpdateEmail('')
                setUpdatePicture('')
                setUpdatePictureUrl('')
                setUpdateCreate(false)
                sethh(true)
            }
        }
    }, [country, echange, email, fullName, phone, updateCountry, updateCreate, updateEmail, updateFullName, updateId, updateImage, updatePhone, updatePicture, updatePictureUrl]);



    useEffect(() => {
        setNoOfPages(Math.ceil((userData.length)/10))
        setNoOfData(userData.length)
        setOffset(10 * activePage)
        setLoadedData(userData.slice((offset - 10), offset))
        setPageArray(numArr(noOfPages))
    }, [activePage, userData, noOfData, noOfPages, offset])

    useEffect(() => {
        if(pageArray.length > 0) {
            document.querySelectorAll('.page-box').forEach(el => {
                el.classList.remove('active')
            })
            if(document.querySelector(`.page${activePage}`) === null) {   
                setActivePage(pageState - 1)
            } else {   
                return document.querySelector(`.page${activePage}`).classList.add('active')
            }   
        }
        
    }, [activePage, userData, pageArray, pageArray.length, pageState])

    useEffect(() => {
        const usersRef = firebase.database().ref('Users')

        usersRef.on('value', (el) => {
            let eData = []
            for (let id in el.val()) {
                eData.unshift({id, ...el.val()[id]})
            }
            setUserData(eData)
        })
    }, [echange])

    useEffect(() => {
        if (membersAlertStatus) {
            if(deleteId) {
                const userRef = firebase.database().ref('Users').child(deleteId)
                userRef.remove()
                setEchange(!echange)
                dispatch(setMembersAlert(false))
                setDeleteId('')
            } 
            
        }
    }, [deleteId, dispatch, echange, membersAlertStatus])

    const handleCloseUserForm = (e) => {
        e.preventDefault()
        setEdit(false)
        setEditId('')
        document.querySelector('.lang-background').classList.add('hide')
        document.querySelector('.mem-form-container').classList.add('hide')
        setPhone('')
        setFullName('')
        setCountry('')
        setEmail('')
        setPicture('')
        setPictureUrl('')
    }

    const handleOpenUserForm = () => {
        document.querySelector('.lang-background').classList.remove('hide')
        document.querySelector('.mem-form-container').classList.remove('hide')
    }



    

    const handleSubmitUserForm = (e) => {
        e.preventDefault()
        setUploadClick(true)
        setUserCreate(true)

        if(!fullName || !email || !phone || !country) {
            setUploadClick(false)
            setUserCreate(false)
            setUploadStage('fail')
            setUploadProgress('Please Complete The Compulsory Fields')
            return
        }

        const bb = userData.some(el => {
            return email === el.email
        })

       

        if (bb) {
            setUploadClick(false)
            setUserCreate(false)
            setUploadStage('fail')
            setUploadProgress('Email Already Exist')
            return 
        }

        if(!picture) {
            setUploadClick(false)

            
            // setUploadStage('fail')
            // setUploadProgress('Please Upload An Image')
            const usersRef = firebase.database().ref('Users')
            const newUser = {
                name: fullName,
                email: email,
                phone: phone,
                country: country,
                joinedAt: new Date(Date.now()).toLocaleString()
            }
            usersRef.push(newUser)
            setEchange(!echange)
            setPhone('')
            setFullName('')
            setCountry('')
            setEmail('')
            setPicture('')
            setPictureUrl('')
            document.querySelector('.lang-background').classList.add('hide')
            document.querySelector('.mem-form-container').classList.add('hide')
            setEdit(false)
            setEditId('')
            setUserCreate(false)
        }

        if(picture) {
            makeUpload(picture, picture.name)
        }
    }

    const handleUserDelete = (id, name, index) => {
        setPageState(activePage)
        setDeleteId(id)
        setAlertMessage(`You are about to delete ${name}'s user profile" \n\nNote all data for this user will be deleted! \n\nAre you sure you want to proceed?`)
        document.querySelector(`.a${id}`).classList.remove('hide')
        let elmnt = document.querySelector(".content-view");
        let y = elmnt.scrollHeight;
        document.querySelector('.lang-background').style.height = `${y + 110}px`
        document.querySelector('.lang-background').classList.remove('hide')
        
        if((index + 1) >= 4) {
            document.querySelector(`.a${id}`).scrollIntoView();   
        }
    }

    const handleUserClone = (id) => {
        if(id) {
            const usersRef = firebase.database().ref('Users')
        const userRef = firebase.database().ref('Users').child(id)
        userRef.on('value', (el) => {
            let newUser
            if (!el.val().profilePicture) {
                newUser = {   
                    name: el.val().name,
                    email: '',
                    phone: el.val().phone,
                    country: el.val().country, 
                    joinedAt: new Date(Date.now()).toLocaleString()
                }
                
            } else {
                newUser = {   
                    name: el.val().name,
                    email: '',
                    phone: el.val().phone,
                    country: el.val().country, 
                    profilePicture: el.val().profilePicture,
                    joinedAt: new Date(Date.now()).toLocaleString()
                }
            }
            
            usersRef.push(newUser)
        })
        setEchange(!echange)
    }
    }

    const [checkEmail, setCheckEmail] = useState(false)

    const handleUserEdit = (id) => {
        setEdit(true)
        setEditId(id)
        if(id) {
            const langRef = firebase.database().ref('Users').child(id)
            langRef.on('value', (el) => {
                setPhone(el.val().phone)
                setFullName(el.val().name)
                setCountry(el.val().country)
                setEmail(el.val().email)
                setCheckEmail(el.val().email)
                setPictureUrl(el.val().profilePicture)
            })
        }
        
        
        document.querySelector('.lang-background').classList.remove('hide')
        document.querySelector('.mem-form-container').classList.remove('hide')
        document.querySelector(`.admin-nav`).scrollIntoView();   
    }
    


    const handleUpdateUserForm = (e, id) => {
        e.preventDefault()
        setUpdateId(id)
        setUploadClick(true)
        setUpdateCreate(true)

        if(!fullName || !email || !phone || !country) {
            setUploadClick(false)
            setUpdateCreate(false)
            setUploadStage('fail')
            setUploadProgress('Please Complete The Compulsory Fields')
            return
        }

        const check = checkEmail === email
        
        if (!check) {
            const bb = userData.some(el => {
                return email === el.email
            })
    
           
    
            if (bb) {
                setUploadClick(false)
                setUserCreate(false)
                setUploadStage('fail')
                setUploadProgress('Email Already Exist')
                return 
            }
        }
        

        setUpdateFullName(fullName)
        setUpdatePhone(phone)
        setUpdateCountry(country)
        setUpdateEmail(email)
        setUpdatePicture(picture)
        setUpdatePictureUrl(pictureUrl)

        if(!picture) {
            
            setPhone(updatePhone)
            setFullName(updateFullName)
            setCountry(updateCountry)
            setEmail(updateEmail)
            setPicture(updatePicture)
            setPictureUrl(updatePictureUrl)

            const userRef = firebase.database().ref('Users').child(id)
            userRef.update({
                name: fullName,
                email: email,
                phone: phone,
                country: country,
                updatedAtDate: Date.now()
            })
            setEchange(!echange)
            setPhone('')
            setFullName('')
            setCountry('')
            setEmail('')
            setPicture('')
            setPictureUrl('')
            setUploadProgress('')
            setUploadStage('')
            setUploadClick(false)
            document.querySelector('.lang-background').classList.add('hide')
            document.querySelector('.mem-form-container').classList.add('hide')
            setEdit(false)
            setEditId('')
            setUpdateFullName('')
            setUpdatePhone('')
            setUpdateCountry('')
            setUpdateEmail('')
            setUpdatePictureUrl('')
            setUpdateId('')
        } else {

            makeUpload(picture, picture.name)  
        }
    }

    const handleViewDetails = (id, index) => {
        document.querySelector(`.card${id}`).classList.remove('hide')
        let elmnt = document.querySelector(".content-view");
        let y = elmnt.scrollHeight;
        document.querySelector('.lang-background').style.height = `${y + 110}px`
        document.querySelector('.lang-background').classList.remove('hide')
        
        if((index + 1) >= 4) {
            document.querySelector(`.card${id}`).scrollIntoView();   
        }
    }



    return (
        <div className='mem-view lang-view events-view'>
            <Helmet htmlAttributes>
                <meta charSet="utf-8" />
                <html lang="en" />
                <title>Admin-Members | LVZConnect</title>
                <meta name="description" content="LVZConnect Admin Languages Page" />
            </Helmet>
            <div className="top">
                <div>
                    <img src={logo1} alt="" />
                    <h3>MEMBERS</h3>
                </div>
                
                <button onClick={handleOpenUserForm}>Add User +</button>
            </div>
            <div className="table-container">
                <div className="table title">
                    <div className="num dd">#</div>
                    <div className="fname dd">FullName</div>
                    <div className="m-email dd">Email Url</div>
                    <div className="mem-c dd">Country</div>
                    <div className="mem-d dd">Date Join</div>
                    <div className="m-actions dd">Actions</div>
                </div>

                {loadedData.map((el, i) => {
                    return (
                        <div className="table details">
                            <Alert message={alertMessage} eventId={el.id} action={setMembersAlert} />
                            <MembersCard id={el.id} imageUrl={el.profilePicture} name={el.name} email={el.email} country={el.country} phone={el.phone} joinedAt={new Date(el.joinedAt).toLocaleString()} />
                            <div className="num dd">{i + 1 + (offset -10)}</div>
                            <div className="fname dd">{el.name}</div>
                            <div className="m-email dd">{el.email}</div>
                            <div className="mem-c dd">{el.country}</div>
                            <div className="mem-d dd">{new Date(el.joinedAt).toLocaleString()} </div>
                            <div className="m-actions dd">
                                <button className='view-details' title='View Details' onClick={()=> handleViewDetails(el.id, i)}><i class="far fa-eye"></i></button>
                                <button className='delete' title='Delete' onClick={()=> handleUserDelete(el.id, el.name, i)}><i class="fas fa-trash-alt"></i></button>
                                <button className='edit' title='Edit' onClick={()=> handleUserEdit(el.id)}><i class="fas fa-edit"></i></button>
                                <button className='clone' title='Clone' onClick={() => handleUserClone(el.id)}><i class="far fa-copy"></i></button>
                            </div>
                        </div>
                    )
                })}
            </div>

            {loadedData.length > 0? 
                <Paginate activePage={activePage} setActivePage={setActivePage} pageArray={pageArray} noOfPages={noOfPages} /> : 
                ''
            }

            

            

            

            

            <div className='mem-form-container hide'>
                <div className="form-close" onClick={handleCloseUserForm}>
                    <i class="fas fa-times"></i>
                </div>
                <h3>
                    {edit? 'Edit User' : 'Add New User'}
                </h3>

                <form action="">
                    <div className="form-element">
                        <label htmlFor="fname">Full Name</label>
                        <input disabled={uploadClick} type="text" id='fname' name='fname' className='field' 
                        value={fullName} onChange={(e) => setFullName(e.target.value)}/>
                    </div>

                    <div className="form-element">
                        <label htmlFor="mem-email">Email</label>
                        <input disabled={uploadClick} type="text" id='mem-email' name='mem-email' className='field'  required
                        value={email} onChange={(e) => setEmail(e.target.value)}/>  
                    </div>

                    <div className="form-element">
                        <label htmlFor="m-p-num">Phone Number</label>
                        <input disabled={uploadClick} type="text" id='m-p-num' name='m-p-num' className='field'  required
                        value={phone} onChange={(e) => setPhone(e.target.value)}/>  
                    </div>

                    <div className="form-element">
                        <label htmlFor="langCode">Country</label> 
                        <select disabled={uploadClick} className='field' name="mem-country" id="mem-country" value={country} onChange={(e) => setCountry(e.target.value)}>
                        <option value="" defaultValue></option>
                            {countryList.map(el => {
                                if(el.name === 'NIGERIA') {
                                return (
                                    <option value={el.name[0].toUpperCase() + el.name.slice(1).toLowerCase()}>{el.name}</option>
                                )
                                }
                            })}
                            {countryList.map(el => {
                                if(el.name === 'UNITED STATES') {
                                return (
                                    <option value={el.name[0].toUpperCase() + el.name.slice(1).toLowerCase()}>{el.name}</option>
                                )
                                }
                            })}

                            {countryList.map(el => {
                                if(el.name === 'UNITED KINGDOM') {
                                return (
                                    <option value={el.name[0].toUpperCase() + el.name.slice(1).toLowerCase()}>{el.name}</option>
                                )
                                }
                            })}

                            {countryList.map(el => {
                                if(el.name === 'SOUTH AFRICA') {
                                return (
                                    <option value={el.name[0].toUpperCase() + el.name.slice(1).toLowerCase()}>{el.name}</option>
                                )
                                }
                            })}

                            {countryList.map(el => {
                                if(el.name === 'CHINA') {
                                return (
                                    <option value={el.name[0].toUpperCase() + el.name.slice(1).toLowerCase()}>{el.name}</option>
                                )
                                }
                            })}

                            {countryList.map(el => {
                                if(el.name === 'TURKEY') {
                                return (
                                    <option value={el.name[0].toUpperCase() + el.name.slice(1).toLowerCase()}>{el.name}</option>
                                )
                                }
                            })}

                            {countryList.map(el => {
                                if(el.name === 'MONGOLIA') {
                                return (
                                    <option value={el.name[0].toUpperCase() + el.name.slice(1).toLowerCase()}>{el.name}</option>
                                )
                                }
                            })}

                            {countryList.map(el => {
                                if(el.name === 'GHANA') {
                                return (
                                    <option value={el.name[0].toUpperCase() + el.name.slice(1).toLowerCase()}>{el.name}</option>
                                )
                                }
                            })}

                            {countryList.map(el => {
                                if(el.name !== 'MONGOLIA' && el.name !== 'GHANA' && el.name !== 'TURKEY' && el.name !== 'CHINA' && el.name !== 'SOUTH AFRICA' && el.name !== 'UNITED KINGDOM' && el.name !== 'UNITED STATES' && el.name !== 'NIGERIA') {
                                    return (
                                        <option value={el.name[0].toUpperCase() + el.name.slice(1).toLowerCase()}>{el.name}</option>
                                    )
                                }
                            })}
                        </select>
                    </div>

                    <div className="form-element">
                        <label htmlFor="mem-pic">Profile Picture</label>
                        <input disabled={uploadClick} type="file" name="mem-pic" id="mem-pic" onChange={(e) => {setPicture(e.target.files[0]) 
                        console.log(e.target.files[0])}}/>
                    </div>

                    <div className='upload-status'>
                        <p>Status:</p>
                        {uploadStage === 'loading'? <p className="loading">{uploadProgress}</p> : uploadStage === 'fail'? <p className="fail">{uploadProgress}</p> : ''}
                    </div> 

                    <div className="buttons">
                        <button disabled={uploadClick} className="close" onClick={handleCloseUserForm}>Close</button>
                        {edit? <button disabled={uploadClick} type="submit" className='submit' onClick={(e) => handleUpdateUserForm(e, editId)}>Update User</button> : <button type="submit" className='submit' onClick={handleSubmitUserForm}>Save User</button>}    
                    </div>

                    
                </form>
            </div>
        </div>
    )

    
}

export default Members